<template>
  <div class="vx-row mb-6">
    <div class="vx-col w-full">
      <h5 class="mb-6">
        {{ $t('Age Range ') + ageRange[0] + ' - ' + (ageRange[1] === 65 ? '65+' : ageRange[1]) }}
      </h5>
      <vs-row>
        <vs-col :key="'target-age-range-' + adsetIndex" vs-type="flex" vs-justify="start" vs-align="center" vs-w="4">
          <vs-slider :disabled="editing && !advertisingChannel.supports_update_targeting && acceptanceStatus" id="create-campaign-s3-age-range-checkbox" class="ml-0" text-fixed="y" :min="18" :max="65" v-model="ageRange"/>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    value: {
      type: Array,
      required: true
    },
    adsetIndex: {
      type: Number,
      required: true
    },
    advertisingChannel: {
      type: Object,
      required: true
    },
    editing: {
      type: Boolean,
      required: true
    },
    acceptanceStatus: {
      type: Boolean | null,
      required: true
    }
  },
  computed: {
    ageRange: {
      set (val) {
        this.$emit('input', val)
      },
      get () {
        return this.value
      }
    }
  }
}
</script>
